module.exports = __webpack_public_path__ + "img/search-qr.4f7601f8.svg";